/**
 * Public-facing plan catalog used by the marketing pricing page +
 * the signup flow. Identical shape on both surfaces so a price /
 * recommended-badge / plan-existence change in the admin only has
 * to land in one place.
 */
export interface PublicPlanFeature {
    name: string;
    slug: string;
    category: string | null;
    limit: number | null;
}

export interface PublicPlan {
    id: string;
    name: string;
    slug: string;
    price_monthly: number;
    price_yearly: number;
    description: string | null;
    is_recommended: boolean;
    features: PublicPlanFeature[];
}

export async function fetchPublicPlans(): Promise<PublicPlan[]> {
    const res = await fetch('/api/v1/public/plans', {
        headers: { Accept: 'application/json' },
    });
    if (!res.ok) {
        throw new Error(`API ${res.status}`);
    }
    const json = (await res.json()) as { data: PublicPlan[] };
    return json.data ?? [];
}
